import { z } from 'zod';

const FiasObjectLooseSchema = z.object({
  objectId: z.number(),
  name: z.string(),
  fullName: z.string().optional()
});

export const LocationSchema = z.object({
  region: z.string().optional(),
  county: z.string().optional(),
  district: z.string().optional(),
  latitude: z
    .number()
    .min(-90, { message: 'Широта должна быть в диапазоне от -90 до 90' })
    .max(90, { message: 'Широта должна быть в диапазоне от -90 до 90' })
    .nullable()
    .optional(),
  longitude: z
    .number()
    .min(-180, { message: 'Долгота должна быть в диапазоне от -180 до 180' })
    .max(180, { message: 'Долгота должна быть в диапазоне от -180 до 180' })
    .nullable()
    .optional(),
  isFias: z.boolean().optional(),
  cityFias: z
    .object({
      objectId: z.number(),
      name: z.string(),
      fullName: z.string()
    })
    .nullable()
    .optional(),
  streetFias: z
    .object({
      objectId: z.number(),
      name: z.string()
    })
    .nullable()
    .optional(),
  houseFias: z
    .object({
      objectId: z.number(),
      name: z.string()
    })
    .nullable()
    .optional(),
  customCity: z.string().optional(),
  customStreet: z.string().optional(),
  customHouse: z.string().optional(),
  excludedStreetsFias: z.array(FiasObjectLooseSchema).optional(),
  excludedHousesFias: z.array(FiasObjectLooseSchema).optional()
});
